import Assets from './assets';

export default Assets;



// WEBPACK FOOTER //
// ./src/components/cards/assets/index.js